import m from "./../../../dist/es2015/themes/Kshow.js";
export const am5themes_Kshow = m;